/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import { func } from 'prop-types';

import { Input } from 'Components';
import './pageFilters.scss';

export default function PageFilters({ onApply = () => {} }) {
  const [searchText, setSearchText] = useState(null);
  const [activeOnly, setActiveOnly] = useState(false);

  function handleTextInputFilter(e) {
    setSearchText(e.target.value);
  }

  function handleActiveOnly() {
    setActiveOnly(!activeOnly);
  } // @to-do Remover função não usada

  function handleApply() {
    onApply({
      searchText,
      activeOnly
    });
  }

  return (
    <div
      className="sdp-card sdp-p-4  sdp-mb-0 search-box"
      data-testid="pageFilters-component"
    >
      <div className="filters-wrap">
        <Input
          type="text"
          name="elementName"
          id="elementName"
          label="Search"
          className="w-100"
          placeholder="Input Keyword"
          onChange={(e) => handleTextInputFilter(e)}
          data-testid="pageFilters-component_searchInput"
        />
      </div>
      <button
        className="sdp-btn sdp-btn--blue sdp-mt-3 w-100 button-search-box"
        type="button"
        onClick={handleApply}
        data-testid="pageFilters-component_applyButton"
      >
        Apply
      </button>
    </div>
  );
}

PageFilters.propTypes = {
  onApply: func
};

PageFilters.defaultProps = {
  onApply: () => {}
};
